export function seasonLabel(number: number): string {
  return `Сезон ${number}`;
}

export function episodeLabel(number: number, title: string): string {
  return `Эпизод ${number} — ${title}`;
}

/**
 * Где в сериале — словами целиком, как просил владелец: «Сезон 1, Эпизод 4».
 * Сокращения «С1 Е4» остаются только плееру и телевизору, где места мало.
 */
export function seasonEpisodeLabel(season: number, episode: number): string {
  return `Сезон ${season}, Эпизод ${episode}`;
}

/** Номер на кадре серии: «Эпизод 6». */
export function episodeNumberLabel(episode: number): string {
  return `Эпизод ${episode}`;
}

/**
 * Что запускается — подпись слоя запуска: «Сезон 1, Эпизод 4 · Название серии».
 *
 * Безымянную серию («Серия 4», «Episode 4») называем только номером: рядом с
 * «Эпизод 4» такое название повторяло бы его другими словами. Правило то же,
 * что у подписи серии в плеере.
 */
export function episodeLaunchLabel(season: number, episode: number, name: string | null | undefined): string {
  const where = seasonEpisodeLabel(season, episode);
  const title = (name ?? '').trim();
  return title === '' || /^(серия|эпизод|episode)\s*\d+$/i.test(title) ? where : `${where} · ${title}`;
}
